"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const router_1 = require("@angular/router");
const historical_alarm_list_component_1 = require("./alarmList/historical-alarm-list.component");
const pending_alarm_list_component_1 = require("./alarmList/pending-alarm-list.component");
const routes = [
    {
        path: 'alarms',
        children: [
            { path: 'historical', component: historical_alarm_list_component_1.HistoricalAlarmListComponent },
            { path: 'pending', component: pending_alarm_list_component_1.PendingAlarmListComponent }
        ]
    }
];
exports.ALARM_ROUTES = router_1.RouterModule.forChild(routes);
